import { BASE48_ALPHABET } from './alphabet';

// Port of the lambda's `base48encode` (longlinks_shortener/api/store.js).
// Divmod-encodes from least to most significant character, stopping once the
// result has reached `maxLength` characters — i.e. the kept digits are the
// least-significant ones, equivalent to taking the value modulo 48^maxLength.
export function base48encode(input: bigint, maxLength: number): string {
	const base = BigInt(BASE48_ALPHABET.length);
	let working = input;
	let result = '';

	do {
		const remainder = working % base;
		result = BASE48_ALPHABET.charAt(Number(remainder)) + result;
		working /= base;
	} while (working > 0n && result.length < maxLength);

	return result;
}
